import { render, staticRenderFns } from "./user-rate.vue?vue&type=template&id=f7ddae8e"
import script from "./user-rate.vue?vue&type=script&lang=js"
export * from "./user-rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports